//# sourceMappingURL=my-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-options.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-options.interface.js
// module chunks = 4